import { Navigation } from '../../pieces/Navigation';
import { NavMenu } from './NavMenu';

export function BottomNav() {
  return (
    <div className="fixed bottom-0 z-40 mx-auto grid w-full place-items-center rounded-sm border-t border-indigo-300/50 dark:border-indigo-800/20 md:hidden">
      <div className="flex h-full w-full flex-row items-center justify-center gap-8 bg-indigo-50/90 p-1 supports-[backdrop-filter]:bg-indigo-100/40 supports-[backdrop-filter]:backdrop-blur dark:bg-gray-900/90 dark:supports-[backdrop-filter]:bg-gray-900/40">
        <div className="flex flex-row whitespace-nowrap">
          <Navigation to="/" icon="material-symbols:home-rounded">
            <span className="max-[329px]:hidden">Home</span>
          </Navigation>
          <NavMenu />
        </div>
      </div>
    </div>
  );
}
